import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { SettingsContextImport } from "../../../../provider/settings/settings/SettingsContextProvider";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import Div from "../../../../widget/common/ui/Div";
import { TextInline } from "../../../../widget/common/ui/Text";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import AppTheme from "../../../../service/app_config/AppTheme";

const SettingsMenu = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const { menuList, handleClick } = SettingsContextImport();

  return (
    <>
      <Listing>
        {(menuList ?? []).map((menu, key) => (
          <ListItem key={key} className="border-0 py-1 plg-2">
            <div role="button" onClick={() => handleClick(menu)}>
              <Div fontName="medium" color="theme-label" fontSize="16_17">
                <TextInline>
                  <IconCircleFilledIcon
                    size={type === 2 ? 50 : 40}
                    name={menu.icon}
                    color={AppTheme.themeFont}
                  />
                </TextInline>
                <TextInline className="ps-3" fontName="medium">
                  {AppTranslation.text(menu.name)}
                </TextInline>
              </Div>
            </div>
          </ListItem>
        ))}
      </Listing>
    </>
  );
};
export default SettingsMenu;
